// import background from '../assets/join.svg';

const Join = () => {
  return (
    <section className="bg-join h-screen flex justify-around items-center bg-cover"></section>
  );
};

export default Join;
